class ProductRecommendations extends HTMLElement {
  constructor () {
    super()

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('product-recommendations')
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }
        })
        .catch(e => {
          console.error(e)
        })
    }
    /* eslint-disable-next-line compat/compat */
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 500px 0px',
    }).observe(this)
  }

  fetchProducts () {
    try {
      return fetch(
        `${this.baseUrl}?section_id=${this.sectionId}&product_id=${this.productId}&limit=${this.limit}&intent=${this.intent}`,
      )
        .then(res => res.text())
        .then(html => {
          const el = document.createElement('div')
          el.innerHTML = html
          this.innerHTML = el.firstElementChild.innerHTML
        })
    } catch (e) {
      console.error(e)
    }
  }

  get baseUrl () {
    return this.dataset.baseUrl
  }

  get limit () {
    return this.dataset.limit
  }

  get productId () {
    return this.dataset.productId
  }

  get intent () {
    return this.dataset.intent
  }

  get sectionId () {
    return this.dataset.sectionId
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations)
}
